@for (row of rowsArr; track row) {
<div class="loader-columns d-flex justify-space-between flex-direction-row w-100 h-100 m-b-10">
    @for (columns of columnsArr; track columns) {
    <div
        class="item {{ loaderClass }}"
        [ngClass]="'width-' + columnsCount"
    >
        <div class="loader w-100 h-100"></div>
    </div>
    } @if (splitColumnByLine) {
    <span class="vertical-bar"></span>
    }
</div>
}
